import { apolloClient } from '~/apollo-client';
import { UpdatePreferenceMutation, UpdatePreferenceMutationVariables } from '~/typings/graphql';
import { UPDATE_LANGUAGE_PREFERENCE_MUTATION } from './update-language-preference.queries';

export type UpdateUserLanguagePreferenceParams = {
  userId: number;
  language: string;
};

export const updateLanguagePreference = async (params: UpdateUserLanguagePreferenceParams) => {
  const { userId, language } = params;
  const { data } = await apolloClient.mutate<
    UpdatePreferenceMutation,
    UpdatePreferenceMutationVariables
  >({
    mutation: UPDATE_LANGUAGE_PREFERENCE_MUTATION,
    variables: {
      id: userId,
      input: {
        languageShortCode: language,
      },
    },
  });

  return {
    id: data?.updateUser?.id,
    languageShortCode: data?.updateUser?.languageShortCode,
  };
};
